import {helper} from "@/services/Helper";
import store from "@/store";

// Index global { route name -> requiredRoles[] }, peuple par router/index.ts
// apres concatenation des routes (pour eviter une circular dependency
// Menu.ts -> route files -> Vue components -> store -> Menu.ts).
const routeRolesIndex: Record<string, string[]> = {};

// Bascule "menu local" : si VUE_APP_USE_LOCAL_MENU=true, on ignore TOTALEMENT le
// menu servi par auth (et le cache localStorage) et on utilise ce fichier Menu.ts
// comme unique source. Pratique en dev pour iterer sans toucher au serveur auth.
export const USE_LOCAL_MENU = process.env.VUE_APP_USE_LOCAL_MENU === 'true';

export function getRouteRequiredRoles(name: string): string[] {
    return routeRolesIndex[name] || [];
}

/**
 * Appele depuis router/index.ts apres avoir concatene toutes les routes.
 * Construit l'index name -> requiredRoles puis re-injecte les roles dans les menus.
 */
export function registerRouteRoles(routes: any[]): void {
    for (const r of routes) {
        if (r && r.name && r.meta && Array.isArray(r.meta.requiredRoles)) {
            routeRolesIndex[r.name] = r.meta.requiredRoles;
        }
    }
    injectRolesIntoMenus();
}

// Convertit un tableau plat de roles (sem OR) au format attendu par auth.checkRoleTabs :
// [[{code:R1}], [{code:R2}], ...] (chaque entree = un AND-group d'un seul role).
function toRolesTab(roles: string[]): any[] {
    return roles.map(code => [{code}]);
}

const menus: any[] = [
    {
        "name": "configuration-index",
        "path": "/configuration/branch/list",
        "label": "Configuration",
        "params": [],
        "icon": "fad fa-gears",
        "subMenus": [
            {"title": null, "name": "configuration-index", "icon": "fad fa-folder-tree", "path": "/configuration/branch/list", "label": "Branches", "params": []},
            {"title": null, "name": "data-type-manager", "icon": "fad fa-input-numeric", "path": "/configuration/data/type", "label": "Type de donn\u00e9es", "params": []},
            {"title": null, "name": "avenant-type-manager", "icon": "fad fa-file-signature", "path": "/configuration/avenant/type", "label": "Avenants", "params": []},
            {"title": null, "name": "tag-manager", "icon": "fad fa-tags", "path": "/configuration/tag", "label": "Tags", "params": []},
            {"title": null, "name": "reason-manager", "icon": "fad fa-question", "path": "/configuration/reason", "label": "Motifs", "params": []},
            {"title": null, "name": "lifecycle-config", "icon": "fad fa-hourglass-clock", "path": "/configuration/lifecycle", "label": "Lifecycle Cotations", "params": []},
            {"title": null, "name": "duration-manager", "icon": "fad fa-stopwatch-20", "path": "/configuration/duration", "label": "Gestion de dur\u00e9es", "params": []},
            {"title": null, "name": "orphan-form-list", "icon": "fad fa-ballot-check", "path": "/configuration/:slug?/survey/list", "label": "Formulaires independants", "params": []},
            {"title": null, "name": "insurer-list", "icon": "fad fa-building-shield", "path": "/configuration/insurer/list", "label": "Assureurs", "params": []},
            {"title": null, "name": "pack-category-list", "icon": "fad fa-boxes-stacked", "path": "/configuration/pack-category/list", "label": "Categories de pack", "params": []},
            {"title": null, "name": "parameters", "icon": "fad fa-cogs", "path": "/configuration/parameters", "label": "Parametres", "params": []},
            {"title": null, "name": "payment-method-list", "icon": "fad fa-money-bills-simple", "path": "/income/payment/method/list", "label": "Methode de paiement", "params": []},
            {"title": null, "name": "platform-list", "icon": "fad fa-folder-tree", "path": "/configuration/platform/list", "label": "Plateformes", "params": []},
            {"title": null, "name": "language-list", "icon": "fad fa-language", "path": "/configuration/language/list", "label": "Traduction", "params": []},
            {"title": "SYSTEME", "name": "system-settings", "icon": "fad fa-sliders", "path": "/configuration/system-settings", "label": "Paramètres système", "params": []},
            {"title": null, "name": "transcriber-provider-manager", "icon": "fad fa-microphone-lines", "path": "/configuration/transcriber-providers", "label": "Transcription audio", "params": []},
            {"title": null, "name": "tts-provider-manager", "icon": "fad fa-volume", "path": "/configuration/tts-providers", "label": "Synthèse vocale (TTS)", "params": []}
        ]
    },
    {
        "name": "income-index",
        "path": "/income",
        "label": "Assurance",
        "params": [],
        "icon": "fad fa-bag-shopping",
        "subMenus": [
            {"title": null, "name": "income-index", "icon": "fad fa-ballot-check", "path": "/income", "label": "Dashboard", "params": []},
            {"title": null, "name": "cotation-list", "icon": "fad fa-list-ol", "path": "/income/cotation/list", "label": "Cotations", "params": []},
            {"title": null, "name": "hot-leads", "icon": "fad fa-fire", "path": "/income/hot-leads", "label": "Prospects chauds", "params": []},
            {"title": null, "name": "payment-list", "icon": "fad fa-money-bills", "path": "/income/payments", "label": "Liste de paiements", "params": []},
            {"title": null, "name": "delivery-list", "icon": "fad fa-person-biking-mountain", "path": "/income/delivery", "label": "Livraisons", "params": []},
            {"title": null, "name": "contract-list", "icon": "fad fa-file-lines", "path": "/income/contract/list", "label": "Contrats", "params": []},
            {"title": null, "name": "avenant-list", "icon": "fad fa-file-doc", "path": "/income/avenant/list", "label": "Liste des avenants", "params": []},
            {"title": null, "name": "customer-list", "icon": "fad fa-user-group", "path": "/income/customer/list", "label": "Clients", "params": []},
            {"title": null, "name": "parrainage-list", "icon": "fad fa-user-group", "path": "/income/parrainage/list", "label": "Liste de parrainage", "params": []},
            {"title": null, "name": "income-import", "icon": "fad fa-file-import", "path": "/income/import", "label": "Import des cotations", "params": []},
            {"title": null, "name": "partner-list", "icon": "fad fa-people-group", "path": "/income/partner/list", "label": "Gestion des partenaires", "params": []},
            {"title": null, "name": "advantage-list", "icon": "fad fa-ticket-perforated", "path": "/income/advantage/list", "label": "Avantages", "params": []},
            {"title": null, "name": "income-state", "icon": "fad fa-list", "path": "/income/state", "label": "Etats", "params": []}
        ]
    },
    {
        "name": "production-dashboard",
        "path": "/production/dashboard",
        "label": "Production",
        "params": [],
        "icon": "fad fa-industry-windows",
        "subMenus": [
            {"title": null, "name": "production-dashboard", "icon": "fad fa-chart-mixed", "path": "/production/dashboard", "label": "Tableau de bord", "params": []},
            {"title": null, "name": "renewal-dashboard", "icon": "fad fa-arrows-repeat", "path": "/monitoring/renewals", "label": "Renouvellements", "params": []},
            {"title": null, "name": "emission-list", "icon": "fad fa-file-certificate", "path": "/income/avenant/list", "label": "Emissions", "params": []},
            {"title": "Rapport", "name": "daily-report", "icon": "fad fa-clipboard-list", "path": "/daily-report", "label": "Rapport Journalier", "params": []},
            {"title": null, "name": "daily-report-input", "icon": "fad fa-pen-to-square", "path": "/daily-report/input", "label": "Saisie quotidienne", "params": []}
        ]
    },
    {
        "name": "crm-index",
        "path": "/crm",
        "label": "CRM",
        "params": [],
        "icon": "fad fa-comments-dollar",
        "subMenus": [
            {"title": "PROSPECTION", "name": "crm-v2-activities", "icon": "fad fa-calendar-days", "path": "/crm/activities", "label": "Activit\u00e9s", "params": []},
            {"title": null, "name": "crm-v2-pipeline", "icon": "fad fa-bars-progress", "path": "/crm/pipeline", "label": "Affaires", "params": []},
            {"title": "", "name": "crm-v2-contacts", "icon": "fad fa-person", "path": "/crm/contacts", "label": "Particuliers", "params": []},
            {"title": null, "name": "crm-v2-companies", "icon": "fad fa-building-memo", "path": "/crm/companies", "label": "Entreprise", "params": []},
            {"title": "SUPPORT", "name": "chat-whatsapp", "icon": "fab fa-whatsapp", "path": "/crm/chat-whatsapp", "label": "Chat Whatsapp", "params": []},
            {"title": null, "name": "chat-whatsapp-old", "icon": "fad fa-clock-rotate-left", "path": "/old/crm/chat-whatsapp", "label": "Chat Whatsapp (ancien)", "params": []},
            {"title": null, "name": "chat-analytics", "icon": "fad fa-chart-line", "path": "/crm/chat-analytics", "label": "Analyse Chat", "params": []},
            {"title": null, "name": "chat-escalations", "icon": "fad fa-triangle-exclamation", "path": "/chat/escalations", "label": "Escalades IA", "params": []},
            {"title": null, "name": "chat-routing", "icon": "fad fa-route", "path": "/configuration/chat-routing", "label": "Routage chatbot", "params": []},
            {"title": null, "name": "chat-flows", "icon": "fad fa-diagram-project", "path": "/crm/chat-flows", "label": "Flows chatbot", "params": []},
            {"title": null, "name": "todo-query-list", "icon": "fad fa-comments-question-check", "path": "/crm/todo/query/list", "label": "Requ\u00eates clients", "params": []},
            {"title": "MARKETING", "name": "campaign-list", "icon": "fad fa-worm", "path": "/crm/campaign/list", "label": "Campagne", "params": []},
            {"title": null, "name": "job-monitoring", "icon": "fad fa-paper-plane", "path": "/crm/envois/suivi", "label": "Suivi des envois", "params": []},
            {"title": "", "name": "sms", "icon": "fad fa-message-sms", "path": "/crm/sms", "label": "SMS", "params": []},
            {"title": null, "name": "sms-template-list", "icon": "fad fa-message-sms", "path": "/crm/template/sms/list", "label": "Modele d'SMS", "params": []},
            {"title": "", "name": "email-template-list", "icon": "fad fa-at", "path": "/crm/email/template/list", "label": "Mod\u00e8le d'email", "params": []},
            {"title": null, "name": "url-shortener", "icon": "fad fa-link", "path": "/crm/url/shortener", "label": "Lien raccourci", "params": []},
            {"title": null, "name": "coupon-manager", "icon": "fad fa-gift-card", "path": "/crm/coupon/manager", "label": "Code Promo", "params": []},
            {"title": "IA", "name": "ai-conversations", "icon": "fad fa-comments", "path": "/monitoring/ai", "label": "Conversations IA", "params": []},
            {"title": "PROJET", "name": "cotation-search", "icon": "fad fa-building-wheat", "path": "/crm/cotation/search", "label": "Cotation Advans", "params": [{"label": "partner", "value": "AD2025"}]},
            {"title": null, "name": "chat-whatsapp-old", "icon": "fab fa-rocketchat", "path": "/old/crm/chat-whatsapp", "label": "Chat Advans", "params": [{"label": "partner", "value": "ADVANS"}]},
            {"title": "", "name": "cotation-search", "icon": "fad fa-list-check", "path": "/crm/cotation/search", "label": "Cotation Leya", "params": [{"label": "partner", "value": "LEYA"}]},
            {"title": null, "name": "chat-whatsapp-old", "icon": "fab fa-rocketchat", "path": "/old/crm/chat-whatsapp", "label": "Chat Leya", "params": [{"label": "partner", "value": "LEYA"}]},
            {"title": null, "name": "crm-v2-exports", "icon": "fad fa-cogs", "path": "/crm/exports", "label": "Export", "params": []}
        ]
    },
    {
        "name": "wicare-index",
        "path": "/wicare/dashboard",
        "label": "WiCare",
        "params": [],
        "icon": "fad fa-mobile-button",
        "subMenus": [
            {"title": null, "name": "wicare-index", "icon": "fad fa-grid-2", "path": "/wicare/dashboard", "label": "Tableau de bord", "params": []},
            {"title": null, "name": "wicare-customer-list", "icon": "fad fa-users", "path": "/wicare/customers", "label": "Utilisateurs", "params": []},
            {"title": null, "name": "wicare-notifications", "icon": "fad fa-message-middle-top", "path": "/wicare/notifications", "label": "Notifications", "params": []},
            {"title": null, "name": "wicare-invitation", "icon": "fad fa-gift-card", "path": "/wicare/invitations", "label": "Invitations", "params": []},
            {"title": null, "name": "wicare-parameters", "icon": "fad fa-gears", "path": "/wicare/parameters", "label": "Param\u00e8tres", "params": []}
        ]
    },
    {
        "name": "accounting-index",
        "path": "/comptabilite",
        "label": "Comptabilit\u00e9",
        "params": [],
        "icon": "fad fa-abacus",
        "subMenus": [
            {"title": "Comptabilit\u00e9", "name": "accounting-index", "icon": "fad fa-abacus", "path": "/comptabilite", "label": "Comptabilit\u00e9", "params": []},
            {"title": null, "name": "accounting-list", "icon": "fad fa-piggy-bank", "path": "/comptabilite/comptes", "label": "Comptes", "params": []}
        ]
    },
    {
        "name": "admin-index",
        "path": "/admin",
        "label": "Administration",
        "params": [],
        "icon": "fad fa-shield-quartered",
        "subMenus": [
            {"title": null, "name": "user-list", "icon": "fad fa-users", "path": "/admin/user/list", "label": "Utilisateurs", "params": []},
            {"title": null, "name": "tenant-list", "icon": "fad fa-split", "path": "/admin/tenant/list", "label": "Tenants", "params": []},
            {"title": null, "name": "role-list", "icon": "fad fa-key-skeleton-left-right", "path": "/admin/role/list", "label": "R\u00f4les", "params": []},
            {"title": null, "name": "menu-manager", "icon": "fad fa-sitemap", "path": "/admin/menu/manager", "label": "Menus", "params": []},
            {"title": null, "name": "api-manager", "icon": "fad fa-server", "path": "/admin/api/manager", "label": "Api", "params": []},
            {"title": "Systeme", "name": "system-health", "icon": "fad fa-heartbeat", "path": "/monitoring/system", "label": "Sante systeme", "params": []},
            {"title": null, "name": "activity-log", "icon": "fad fa-clipboard-list", "path": "/monitoring/activity", "label": "Journal d'activite", "params": []},
            {"title": null, "name": "access-denied-log", "icon": "fad fa-lock", "path": "/monitoring/access-denied", "label": "Journal des refus", "params": []},
            {"title": null, "name": "ai-provider-manager", "icon": "fad fa-robot", "path": "/configuration/ai/providers", "label": "Providers IA", "params": []},
            {"title": null, "name": "ai-directive-manager", "icon": "fad fa-brain", "path": "/configuration/ai/directives", "label": "Directives IA", "params": []},
            {"title": null, "name": "whatsapp-account-manager", "icon": "fad fa-comment-dots", "path": "/configuration/whatsapp/accounts", "label": "Comptes WhatsApp", "params": []},
            {"title": null, "name": "retell-account-manager", "icon": "fad fa-phone", "path": "/configuration/retell/accounts", "label": "Comptes Retell", "params": []}
        ]
    },
    {
        "name": "partner-admin-users",
        "path": "/partner/users",
        "label": "Agence",
        "params": [],
        "icon": "fad fa-building-shield",
        "subMenus": [
            {"title": null, "name": "partner-admin-index", "icon": "fad fa-stairs", "path": "/partner/hierarchy", "label": "Hi\u00e9rarchie", "params": []},
            {"title": null, "name": "partner-agencies", "icon": "fad fa-house-building", "path": "/partner/agences", "label": "Agences", "params": []},
            {"title": null, "name": "partner-admin-users", "icon": "fad fa-square-user", "path": "/partner/users", "label": "Utilisateur", "params": []},
            {"title": null, "name": "partner-permissions", "icon": "fad fa-shield-check", "path": "/partner/permissions", "label": "Permissions", "params": []}
        ]
    }
]

function injectRolesIntoMenus(): void {
    const missing: string[] = [];
    for (const menu of menus) {
        if (Array.isArray(menu.subMenus) && menu.subMenus.length > 0) {
            const unionSet = new Set<string>();
            for (const sub of menu.subMenus) {
                const subRoles = getRouteRequiredRoles(sub.name);
                if (subRoles.length === 0) missing.push(sub.name);
                sub.roles = toRolesTab(subRoles);
                for (const r of subRoles) unionSet.add(r);
            }
            menu.roles = toRolesTab(Array.from(unionSet));
        } else {
            const roles = getRouteRequiredRoles(menu.name);
            if (roles.length === 0) missing.push(menu.name);
            menu.roles = toRolesTab(roles);
        }
    }
    if (missing.length > 0 && process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        // console.warn('[Menu.ts] Entrees sans requiredRoles dans les routes :', missing);
    }
}

// Initialisation : tous les menus a roles=[] tant que registerRouteRoles n'a pas ete appelee.
injectRolesIntoMenus();

const routes: [] = []

export function getMenu(name: any) {
    const menuList = menus
    const routeList = store.state.mainStore.routes ?? []
    const routes = menuList.concat(routeList)
    for (let menu of routes) {
        if (menu.name === name && menu.roles && !helper.empty(menu.roles)) {
            return menu;
        }
        if (menu.subMenus) {
            for (let sub of menu.subMenus) {
                if (sub.name === name) {
                    return sub
                }
            }
        }
    }
}

export default menus;
